import LearnPageLayout from "@/components/LearnPageLayout";
import { page9 } from "./learnDataP9";

const TmsForAnxietyOcdPtsdPage = () => (
  <LearnPageLayout
    title={page9.title}
    description={page9.description}
    canonical={page9.canonical}
    h1={page9.h1}
    breadcrumbLabel={page9.breadcrumbLabel}
    crumbs={page9.crumbs}
    shortAnswer={page9.shortAnswer}
    keyTakeaways={page9.keyTakeaways}
    sections={page9.sections}
    faqs={page9.faqs}
    sources={page9.sources}
    schemaJson={page9.schemaJson}
    relatedLinks={page9.relatedLinks}
  />
);

export default TmsForAnxietyOcdPtsdPage;
